import Layout from './Layout';
import ListPageLayout from './ListPageLayout';

export default Layout;

export { ListPageLayout };
